module.exports = __webpack_public_path__ + "static/media/18.b326d584.png";